// export const HOST_API_URL = `https://api.si-pus.com/api/`;
// export const HOST_API_VERSION = `v1`;

// development
// export const HOST_API_URL = `https://6rxbz15osd.si-pus.com/api/`;
export const HOST_API_URL = `https://api.simbanggakencanabantul.com/api/`;
// export const HOST_API_URL = `http://localhost:8000/api/`;
export const HOST_API_VERSION = `v1`;
